import { render, staticRenderFns } from "./StepsHorizontal.vue?vue&type=template&id=59ada622"
import script from "./StepsHorizontal.vue?vue&type=script&lang=js"
export * from "./StepsHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports